<template>
  <div class="wrapper">
    <div class="contentBox">
      <div>
        <h3>
          <el-link icon="el-icon-arrow-left" @click="goTo()"></el-link>
          &emsp;论文名称：{{
            paperData.paperName
          }}&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          {{ paperData.reviewStatus }}
        </h3>
      </div>
      <el-divider></el-divider>
      <div>
        <h2>审批信息</h2>
      </div>
      <div class="tableData">
        <div class="flex-table">
          <div class="flex-item">
            <div class="title">论文名称</div>
            <div class="value">
              <el-button type="text" @click="pdfShow(paperData.paperUrl)">{{
                paperData.paperName
              }}</el-button>
            </div>
          </div>

          <div class="flex-item">
            <div class="title">考试名称</div>
            <div class="value">{{ paperData.testName }}</div>
          </div>
          <div class="flex-item">
            <div class="title">开题报告</div>
            <div class="value">
              <el-button
                type="text"
                @click="pdfShow(paperData.openQuestionReport)"
                >{{ paperData.reportName }}</el-button
              >
            </div>
          </div>
          <div class="flex-item">
            <div class="title">答辩PPT</div>
            <div class="value">
              <div class="value">
                <el-button
                  type="text"
                  v-if="paperData.replyUrl"
                  @click="download(paperData.replyUrl)"
                  >点击下载</el-button
                >
              </div>
            </div>
          </div>
          <div class="flex-item">
            <div class="title">提交时间</div>
            <div class="value">{{ paperData.createTime }}</div>
          </div>
          <div class="flex-item">
            <div class="title">提交人员</div>
            <div class="value">{{ paperData.userName }}</div>
          </div>
          <div class="flex-item">
            <div class="title">审核状态</div>
            <div class="value">{{ paperData.reviewStatus }}</div>
          </div>
        </div>
      </div>
      <h2>开题报告信息</h2>
      <div class="tableBox">
        <div class="tableBar darkBg">
          <div class="flex2 tableCell">指导老师分类</div>
          <div class="flex2 tableCell">姓名</div>
          <div class="flex3 tableCell">工作单位</div>
          <div class="flex1 tableCell">职称</div>
          <div class="flex1 tableCell">学历</div>
          <div class="flex3 tableCell">附件</div>
        </div>
        <div class="tableBar">
          <div class="flex2 tableCell">高校指导老师</div>
          <div class="flex2 tableCell">
            {{ paperData.universityTeacherName }}
          </div>
          <div class="flex3 tableCell">{{ paperData.universityEmployer }}</div>
          <div class="flex1 tableCell">{{ paperData.universityJobTitle }}</div>
          <div class="flex1 tableCell">{{ paperData.universityEducation }}</div>
          <div class="flex3 tableCell">
            <el-button
              type="text"
              v-if="paperData.universityRecommend"
              @click="download(paperData.universityRecommend)"
              >推荐信息</el-button
            >
          </div>
        </div>
        <div class="tableBar darkBg fullBorder">
          <div class="flex2 tableCell">行业指导老师</div>
          <div class="flex2 tableCell">{{ paperData.industryTeacherName }}</div>
          <div class="flex3 tableCell">{{ paperData.industryEmployer }}</div>
          <div class="flex1 tableCell">{{ paperData.industryJobTitle }}</div>
          <div class="flex1 tableCell">{{ paperData.industryEducation }}</div>
          <div class="flex3 tableCell">
            <el-button
              type="text"
              v-if="paperData.industryRecommend"
              @click="download(paperData.industryRecommend)"
              >推荐信息</el-button
            >
          </div>
        </div>
      </div>
      <h2>评分记录</h2>
      <div class="reviewList">
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(scoresInDate, scoreKey) in scoreRecords"
            :key="scoreKey"
            :color="'#36aafd'"
            :timestamp="scoreKey"
            placement="top"
          >
            <div
              class="scoreTable"
              v-for="(score, scoreIdx) in scoresInDate"
              :key="'scoreTable' + scoresInDate + scoreIdx"
            >
              <div class="scoreBar">
                <div class="scoreItem"></div>
                <div
                  class="scoreItem"
                  v-for="(scoreDetail, scoreDetailIdx) in score"
                  :key="
                    'scoreItem' +
                    scoreKey +
                    scoreDetail.auditTeacher +
                    scoreDetailIdx
                  "
                >
                  {{ scoreDetail.scoreItemName }}
                </div>
                <div class="scoreItem">总分</div>
                <div class="scoreItem">评分人</div>
              </div>
              <div class="scoreBar">
                <div class="scoreItem">总分</div>
                <div
                  class="scoreItem"
                  v-for="(scoreDetail, scoreDetailIdx) in score"
                  :key="
                    'scoretotal' +
                    scoreKey +
                    scoreDetail.auditTeacher +
                    scoreDetailIdx
                  "
                >
                  {{ scoreDetail.maxScore }}
                </div>
                <div class="scoreItem">
                  {{
                    score.reduce(
                      (total, sc) => total + parseInt(sc.maxScore),
                      0
                    )
                  }}
                </div>
                <div class="scoreItem"></div>
              </div>
              <div class="scoreBar">
                <div class="scoreItem">得分</div>
                <div
                  class="scoreItem"
                  v-for="(scoreDetail, scoreDetailIdx) in score"
                  :key="
                    'scoreget' +
                    scoreDetail.auditTeacher +
                    scoreDetail.scoreItemName +
                    scoreDetailIdx
                  "
                >
                  {{ scoreDetail.score }}
                </div>
                <div class="scoreItem">
                  {{
                    score.reduce((total, sc) => total + parseInt(sc.score), 0)
                  }}
                </div>
                <div class="scoreItem">{{ score[0].auditTeacher }}</div>
              </div>
            </div>
            <!-- <span> {{ score }}</span> -->
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <el-dialog
      title="论文预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
    >
      <pdf-preview :url="pdfData.pdfUrl"></pdf-preview>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPaperReviewDetail,
  getMyPaperList,
  reviewOnePaper,
} from "@/api/paper.js";
import pdfPreview from "@/views/my-components/other/pdf/pdfPreview.vue";
export default {
  data() {
    return {
      paperData: {},
      type: "",
      reviewData: {
        pdfUrl: null,
        paperId: "",
        reviewStatus: 0,
        reviewDec: "",
        userId: "",
      },
      tableData: [
        { title: "论文名称", value: "" },
        { title: "考试名称", value: "" },
        { title: "开题报告", value: "" },
        { title: "提交时间", value: "" },
        { title: "提交人员", value: "" },
        { title: "审核状态", value: "" },
        { title: "答辩PPT", value: "" },
      ],

      reverse: true,
      scoreRecords: [],
      pdfData: {
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
    };
  },
  components: { pdfPreview },
  created() {},
  mounted() {
    this.getPaperReviewDetail();
  },
  methods: {
    download(url) {
      window.open(url, "_blank");
    },
    pdfShow(url) {
      this.pdfData.pdfUrl = url;
      this.pdfData.pdfIfShow = true;
    },
    getPaperReviewDetail() {
      let params = {
        id: this.$route.query.id,
      };
      (this.type = this.$route.query.type),
        getPaperReviewDetail(params).then((data) => {
          console.log("data", data);

          this.scoreRecords = data.scoreList;
          this.pdfData.pdfUrl = data.paperUrl;
          this.paperData = data;
        });
    },

    goTo(type) {
      var url = "";
      if (this.type == 1) {
        url = "thesisAuditList";
      } else {
        url = "myThesis";
      }
      this.$router.push({ name: url });
    },

    reviewSubmit(item) {
      (this.reviewData.id = this.$route.query.id),
        (this.reviewData.reviewStatus = item),
        (this.reviewData.userId = this.$route.query.userId),
        console.log("审核提交的数据", this.reviewData);
      reviewOnePaper(this.reviewData).then(() => {
        this.goTo(1);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  font-size: 12px;
  margin: 15px;

  .contentBox {
    padding: 20px;

    .tableData {
      padding: 20px;

      .flex-table {
        .flex-item {
          display: flex;
          align-items: center;
          font-size: 16px;
          border: 1px solid #ccc;
          border-bottom-width: 0;
          &:last-child {
            border-bottom: 1px solid #ccc;
          }
          .title {
            display: flex;
            align-items: center;
            width: 160px;
            background-color: #f5f5f5;
            border-right: 1px solid #ccc;
            padding: 5px;
          }

          .value {
            flex: 1;
            display: flex;
            align-items: center;
            padding: 0 10px;
            background-color: #fff;
            /deep/ .el-button {
              padding: 0;
            }
          }
        }
      }

      　　.infoTable {
        font-size: 12px;
        color: #71787e;
        border-collapse: collapse;
        text-align: center;
        padding-top: 20px;
      }

      　　.infoTable tr td {
        border: 1px solid #e6eaee;
        width: 150px;
        height: 35px;
        line-height: 35px;
        box-sizing: border-box;
        padding: 0 10px;
      }

      　　.infoTable tr td.column {
        background-color: #eff3f6;
        color: #393c3e;
      }
    }
  }

  .reviewDes {
    padding: 20px;
    width: 60%;
    height: 300px;
  }

  .reviewList {
    padding: 20px;

    span {
      font-size: 16px;
    }
  }

  .reviewBar {
    text-align: center;
  }
  .tableBox {
    .tableBar {
      display: flex;
      min-width: 800px;
      font-size: 14px;
      border-right: 1px solid #999;
      .tableCell {
        border-top: 1px solid #999;
        border-left: 1px solid #999;
        padding: 6px 3px;
      }
    }
    .fullBorder {
      .tableCell {
        border-bottom: 1px solid #999;
        padding: 6px 3px;
      }
    }
    /deep/ .el-button--text {
      padding: 0;
    }
  }
}
.flex1 {
  flex: 1;
}
.flex2 {
  flex: 2;
}
.flex3 {
  flex: 3;
}
.darkBg {
  background: rgba(0, 0, 0, 0.05);
}
.scoreTable {
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  margin-bottom: 15px;
  .scoreBar {
    display: flex;

    .scoreItem {
      flex: 1;
      line-height: 24px;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      text-indent: 10px;
    }
  }
}
</style>


